import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, ExternalLink } from 'lucide-react';
import Calculator from './Calculator';
import './CalculatorModal.css';

/**
 * Modal/bottom-sheet shell around the Calculator. Mobile-first:
 * full-width sheet on phones, centered card on tablets+.
 *
 * Props:
 *   open (bool)
 *   onClose (fn)
 */
const CalculatorModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="rsc-calc-modal" role="dialog" aria-modal="true" aria-label="Calculator">
      <div className="rsc-calc-modal__backdrop" onClick={onClose} aria-hidden="true" />
      <div className="rsc-calc-modal__sheet">
        <div className="rsc-calc-modal__grip" aria-hidden="true" />
        <header className="rsc-calc-modal__header">
          <div className="rsc-calc-modal__title">
            <span className="rsc-calc-modal__eyebrow">Quick utility</span>
            <span className="rsc-calc-modal__heading">Calculator</span>
          </div>
          <div className="rsc-calc-modal__actions">
            <Link
              to="/utilities/calculator"
              className="rsc-calc-modal__open"
              onClick={onClose}
              title="Open full page"
            >
              <ExternalLink size={14} aria-hidden="true" />
              <span>Open page</span>
            </Link>
            <button
              type="button"
              className="rsc-calc-modal__close"
              onClick={onClose}
              aria-label="Close"
            >
              <X size={18} aria-hidden="true" />
            </button>
          </div>
        </header>
        <div className="rsc-calc-modal__body">
          <Calculator compact />
        </div>
      </div>
    </div>
  );
};

export default CalculatorModal;
